import { Component, Input } from '@angular/core';
import { Field, JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { ImageFieldValue } from '@core/jss-models';
import { NgClass } from '@angular/common';

import { BlogLabelComponent } from '../blog-label/blog-label.component';

@Component({
  selector: 'wl-blog-post[title][description][url][labels][readMoreLabel]',
  templateUrl: './blog-post.component.html',
  styleUrls: ['./blog-post.component.ed.scss'],
  standalone: true,
  imports: [BlogLabelComponent, NgClass, JssModule],
})
export class BlogPostComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() description!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() image?: ImageFieldValue;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() url!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() labels!: string[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() readMoreLabel!: Field<string>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() a11yReadMoreLabel?: Field<string>;
}
